<template>
  <v-card>
    <v-toolbar
      color="primary"
      dark
    >
      <v-toolbar-title>Scores for: {{revealedCategoryScore.category.name}}</v-toolbar-title>
    </v-toolbar>
    <p class="text-xs-center headline mt-4">You earned {{revealedCategoryScore.totalEarnedPoints}} out of {{totalPossible}} total points</p>
    <v-list
      v-for="question in revealedCategoryScore.scoredQuestions"
      v-bind:key="question.questionId"
      three-line
      subheader
    >
      <v-divider></v-divider>
      <v-subheader class="subheading">{{question.heading}}</v-subheader>
      <v-subheader class="caption">{{question.body}}</v-subheader>
      <v-list-tile
        v-for="segment in question.segments"
        :key="segment.text"
        class="ma-1"
      >
        <v-icon :color="segment.earnedPoints === segment.pointsValue ? 'green' : 'red'"
        >{{segment.earnedPoints === segment.pointsValue ? 'check' : 'close'}}</v-icon>
        <v-list-tile-content class="ml-4">
          <v-list-tile-title :class="[segment.earnedPoints === segment.pointsValue ? 'green--text' : 'red--text']">You earned {{segment.earnedPoints}} out of {{segment.pointsValue}} pts</v-list-tile-title>
          <v-list-tile-sub-title>{{segment.text}} = {{getAcceptedAnswersString(segment.acceptedAnswers)}}
          </v-list-tile-sub-title>
          <v-list-tile-sub-title>
            Your answer: {{segment.submittedAnswerText || "No answer submitted" }}
          </v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-card>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "CategoryResults",
  data() {
    return {};
  },
  methods: {
    getAcceptedAnswersString(acceptedAnswers) {
      let acceptedAnswersString = "";
      for (var i = 0; i < acceptedAnswers.length; i++) {
        acceptedAnswersString += acceptedAnswers[i];
        if (i != acceptedAnswers.length - 1) {
          acceptedAnswersString += " OR ";
        }
      }
      return acceptedAnswersString;
    }
  },
  computed: {
    ...mapState("client", {
      revealedCategoryScore: state => state.game.revealedScore
    }),
    ...mapGetters("client", {
      totalPossible: "getTotalPossiblePoints"
    })
  }
};
</script>